import { FormSection } from '../../components/ui/FormSection';

interface ContactInformationSectionProps {
  phone: string;
  onPhoneChange: (value: string) => void;
  email: string;
  onEmailChange: (value: string) => void;
  website: string;
  onWebsiteChange: (value: string) => void;
}

export const ContactInformationSection = ({
  phone,
  onPhoneChange,
  email,
  onEmailChange,
  website,
  onWebsiteChange,
}: ContactInformationSectionProps) => (
  <FormSection title="Contact Information">
    <div>
      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
        Phone
      </label>
      <input
        type="tel"
        id="phone"
        value={phone}
        onChange={(e) => onPhoneChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md"
        placeholder="(707) 555-1234"
      />
    </div>

    <div>
      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
        Email
      </label>
      <input
        type="email"
        id="email"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md"
        placeholder="info@winery.com"
      />
    </div>

    <div>
      <label htmlFor="website" className="block text-sm font-medium text-gray-700 mb-1">
        Website
      </label>
      <input
        type="url"
        id="website"
        value={website}
        onChange={(e) => onWebsiteChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md"
        placeholder="https://www.winery.com"
      />
    </div>
  </FormSection>
);
